<template>
  <div>
    <div class="text-xl font-bold">Structure</div>
    <div class="text-white-070 mt-2 mb-4" style="word-break: break-all">
      {{ state.info.structure }}
    </div>
    <div
      class="bg-white-005 rounded px-2 py-6"
      v-if="state.info.parent.name || state.info.sub.length > 0"
    >
      <router-link
        :to="`/dao/${state.info.parent.daoPath}`"
        v-if="state.info.parent.name"
      >
        <div class="flex flex-col items-center">
          <UiImg
            class="w-12 h-12 rounded-full overflow-hidden"
            :src="state.info.parent.logo"
            style="border: 2px solid #ff5585ff"
          ></UiImg>
          <div class="font-bold">{{ state.info.parent.name }}</div>
        </div>
      </router-link>

      <div class="flex justify-center my-2" v-if="state.info.parent.name">
        <div class="h-4 bg-whitebase" style="width: 1px"></div>
      </div>

      <div class="flex flex-col items-center">
        <UiImg
          class="w-12 h-12 rounded-full overflow-hidden"
          :src="daoPageInfo.vueState.info.logo"
          style="border: 2px solid #ff5585ff"
        ></UiImg>
        <div class="font-bold">{{ daoPageInfo.vueState.info.name }}</div>
      </div>

      <img
        v-if="state.info.sub.length > 0"
        class="w-4/5 mx-auto block my-2"
        src="@/assets/images/ovline.avif"
        alt=""
      />

      <div class="flex justify-between">
        <router-link
          v-for="(item, i) in state.info.sub"
          :key="i"
          :to="`/dao/${item.daoPath}`"
        >
          <div class="w-24 flex flex-col items-center">
            <UiImg
              class="w-8 h-8 rounded-full overflow-hidden"
              :src="item.logo"
            ></UiImg>
            <div style="word-break: break-all" class="text-center">
              {{ item.name }}
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { queryOvDaoRelation } from '@/api/dao';
import { useReqByBool } from '@/hooks';
import { inject, onMounted, reactive } from 'vue';
import UiImg from '@/components/UiImg.vue';

const daoPageInfo = inject('daoPageInfo');

const state = reactive({
  info: {
    parent: {},
    sub: [],
    structure: '',
  },
});

const { loadData, loading } = useReqByBool(async () => {
  const res = await queryOvDaoRelation(daoPageInfo.vueState.info.id);
  console.log(res);
  const { parent, sub, structure } = res;
  state.info = {
    parent: parent || {},
    sub: sub || [],
    structure: structure,
  };
});

onMounted(() => {
  loadData();
});
</script>

<style lang="scss" scoped></style>
